import {Component, Input} from "@angular/core";

@Component({
  selector: "admin-panel-configurable",
  templateUrl: "./configurable.component.html",
  styleUrls: ["./configurable.component.css"]
})
export class AdminPanelConfigurableComponent {

  @Input() title: string = "";
  @Input() border: string = "";
  @Input() customs: string = "";

}
